import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { PackageDeployerFormGzDataProviderFactory } from '../factory/PackageDeployerFormGzDataProviderFactory';
import { PackageDeployerFormBaseDataProvider } from '../dataProvider/PackageDeployerFormBaseDataProvider';
import { DeployerGridResponses, UpdateServerLocationResponse } from '../../deployerGrid/types/deployer-grid-responses';

export class PackageDeployerFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PackageDeployerFormGzDataProviderFactory;
  public dataProvider: PackageDeployerFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PackageDeployerFormGzDataProviderFactory(),
    });
  }

  public async getSuperAgentsForCompany(companyId: string | undefined): Promise<DeployerGridResponses> {
    return await this.dataProvider.getSuperAgentsForCompany(companyId);
  }

  public async getUpdateServerLocation(): Promise<UpdateServerLocationResponse> {
    return await this.dataProvider.getUpdateServerLocation();
  }
}
